"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SNOWPLOW_DATA_LAYER_NAME = exports.ANGI_PRO_CONTAINER_ID = exports.ANGI_HOMEOWNER_CONTAINER_ID = void 0;
exports.ANGI_HOMEOWNER_CONTAINER_ID = 'GTM-N9NBVVNB';
exports.ANGI_PRO_CONTAINER_ID = 'GTM-MKPKZPCK';
exports.SNOWPLOW_DATA_LAYER_NAME = 'snowplowDataLayer';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGFudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcmVhY3QvZ29vZ2xlVGFnTWFuYWdlci9jb250YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDJCQUEyQixHQUFHLGNBQWMsQ0FBQztBQUU3QyxRQUFBLHFCQUFxQixHQUFHLGNBQWMsQ0FBQztBQUV2QyxRQUFBLHdCQUF3QixHQUFHLG1CQUFtQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/react/googleTagManager/contants.ts